import React, { useContext, useMemo, useSyncExternalStore } from "react";
import { ClientAppSettings as ClientAppSettings1 } from "../api-client";
import { ClientAppSettings as ClientAppSettings2 } from "../core-api-client";
import { store } from "../../store";

export type ClientAppSettings =
    ClientAppSettings1 &
    ClientAppSettings2 &
    {
        domainName: string;
    };

export const SettingsContext: React.Context<ClientAppSettings> = React.createContext(null);
export const useSettings: () => ClientAppSettings = () => useContext(SettingsContext);
export const SettingsProvider = ({
    settings,
    children
}: { settings: ClientAppSettings, children: any }) => {
    // Observe the Redux store directly (the provider sits above the react-redux <Provider>, so
    // useAppSelector is unavailable here).  loadAppData writes the complete, authenticated,
    // branch-specific settings into state.app.settings; mirroring them here keeps every
    // useSettings() consumer current after authentication and on branch switches.  The snapshot
    // must return the stable Redux reference so useSyncExternalStore doesn't loop.
    const reduxSettings = useSyncExternalStore(
        store.subscribe,
        () => store.getState().app.settings
    );

    // The bootstrap `settings` prop is the base for the brief pre-LOAD_APP window; Redux values
    // win once populated.
    const value = useMemo(
        () => ({ ...settings, ...reduxSettings }),
        [settings, reduxSettings]
    );

    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider >
    );
};